import React from "react";
import { useTranslation } from "react-i18next";

import { PickupRequestListItem } from "../../../../types";

import TwoLineGridCell from "../TwoLineGridCell";

interface Props {
  data: PickupRequestListItem;
}

const CarrierGridCell = ({ data }: Props) => {
  const { t } = useTranslation();
  const name = [data.carrierFirstName, data.carrierLastName]
    .filter(Boolean)
    .join(" ");

  return (
    <TwoLineGridCell
      firstLineData={name || t("pickupRequests.grid.awaitingAssignment")}
    />
  );
};

export default CarrierGridCell;
